import constants from './constants.js'
import store from './store.js'

export default function handler(to, from, next) {

	// eslint-disable-next-line
	// ga('set', 'page', to.fullPath)

	// eslint-disable-next-line
	// ga('send', 'pageview')

	if (!store.getters['session/loggedin'] && to.matched.some(record => record.meta.requireLogin)) {

		next({
			name: (to.matched.some(record => record.meta.requireLogin)) ? 'Login/Business' : 'Login/Customer'
		})

	} else if (store.getters['session/loggedin'] && to.matched.some(record => record.meta.requireLogout)) {

		next({
			name: 'Dashboard'
		})

	} else if (store.getters['session/type'] !== constants.context.customer && to.matched.some(record => record.meta.requireCustomer)) {

		next({
			name: (store.getters['session/loggedin']) ? 'Dashboard' : 'Login/Customer'
		})

	} else if (store.getters['session/type'] !== constants.context.business && to.matched.some(record => record.meta.requireBusiness)) {

		next({
			name: (store.getters['session/loggedin']) ? 'Dashboard' : 'Login/Business'
		})

	} else {

		next()

	}
	
}